import React from "react";

import type { GlossaryTerm } from "@/components/exercises/exercise.interfaces";
import { cn } from "@/lib/utils";

import { GlossaryTermBox } from "./GlossaryTermBox";
import { glossaryTermGridClass, sortTerms } from "./glossary.utils";

export type GlossaryTermGridProps = {
  terms: GlossaryTerm[];
  expandedTermIds: Set<string>;
  onToggle: (termId: string) => void;
  className?: string;
};

export function GlossaryTermGrid({
  terms,
  expandedTermIds,
  onToggle,
  className,
}: GlossaryTermGridProps) {
  return (
    <div className={cn(glossaryTermGridClass, className)}>
      {sortTerms(terms).map((term) => (
        <GlossaryTermBox
          key={term.id}
          term={term}
          isExpanded={expandedTermIds.has(term.id)}
          onToggle={onToggle}
        />
      ))}
    </div>
  );
}
